import {Component, OnDestroy, OnInit} from '@angular/core';
import {FormGroup, FormBuilder, Validators} from '@angular/forms';
import {takeUntil} from 'rxjs/operators';
import swal from 'sweetalert2';
import {Router} from '@angular/router';
import {ApiService,StrongPasswordRegx} from '../../service/api.service';
import {Subject} from 'rxjs';
import { HelperService } from '../../service/helper.service';
import {TranslateService} from "@ngx-translate/core"
import { EncryptionService } from '../../service/encryption.service';
import {CustomPasswordValidator} from '../../store/custom-password-validator'

@Component({
  selector: 'app-set-password',
  templateUrl: './set-password.component.html',
  styleUrls: ['./set-password.component.scss']
})
export class SetPasswordComponent implements OnInit, OnDestroy {
  hide = true;
  hide_1 = true;

  resetPasswordForm: FormGroup;
  private destroy$ = new Subject();
  companyId: any;
  userLoginData: any;
  constructor(private formBuilder: FormBuilder,
              private router: Router,
              private Api: ApiService,  private encryptionService: EncryptionService,
              private translate: TranslateService) {
    this.resetPasswordForm = this.formBuilder.group({
        currentPassword: [null, Validators.compose([Validators.required, HelperService.noWhitespaceValidator])],
        password: ['', [Validators.required, Validators.pattern(StrongPasswordRegx)]],
        confirmPassword: [null, [Validators.required]]
      },
      {validator: this.ConfirmedValidator('password', 'confirmPassword')}
    );
  }

  ngOnInit(): void {
    // const loginUser = this.encryptionService.getDataFromLocalStorage('NPLoginId');
    const loginUserData = this.encryptionService.getDataFromLocalStorage('NPLoggedInUser');
    this.userLoginData = JSON.parse(loginUserData);
    // this.companyId = JSON.parse(loginUser);
    if(this.userLoginData?.isOtpSent){
      // add otp field inside form
      this.resetPasswordForm.addControl('otp', this.formBuilder.control('', [Validators.required, Validators.minLength(6)]));
    }
  }

  get password() {
    return this.resetPasswordForm.get('password');
  }

  get confpassword() {
    return this.resetPasswordForm.get('confirmPassword');
  }

  onSubmit(): void {
    // this.router.navigate(['login']);
    if (this.resetPasswordForm.valid) {
      const body = {
        "email": this.userLoginData?.email,
        "oldPassword": this.resetPasswordForm.controls['currentPassword'].value,
        "password": this.resetPasswordForm.controls['confirmPassword'].value,
      }
      if (this.userLoginData?.isOtpSent) {
        body['otp'] = this.resetPasswordForm.controls['otp'].value
      }
      this.Api.resetPassword(body)
        .pipe(takeUntil(this.destroy$))
        .subscribe((data) => {
          console.log('data', data)
          this.router.navigate(['/']);
          swal.fire(
            '',
            this.translate.instant(data.message),
            'success'
          );
        }, (error) => {
          const e = error.error;
          swal.fire(
            'Info!',
            e.message,
            'info'
          );
        });
    }
  }

  ConfirmedValidator(controlName: string, matchingControlName: string) {
    return (formGroup: FormGroup) => {
      const control = formGroup.controls[controlName];
      const matchingControl = formGroup.controls[matchingControlName];
      if (matchingControl.errors && !matchingControl.errors['confirmedValidator']) {
        return;
      }
      if (control.value !== matchingControl.value) {
        matchingControl.setErrors({ confirmedValidator: true });
      } else {
        matchingControl.setErrors(null);
      }
    }
  }


  ngOnDestroy(): void {
    this.destroy$.next();  // trigger the unsubscribe
    this.destroy$.complete(); // finalize & clean up the subject stream
  }
  public space(event:any) {
    if (event.target.selectionStart === 0 && event.code === 'Space'){
      event.preventDefault();
    }
  }

  resendOTP() {
      this.Api.forgotPassword({ email: this.userLoginData?.email }).pipe(takeUntil(this.destroy$)).subscribe((data) => {
        if (data.data.isEmailSent) {
          swal.fire(
            '',
            this.translate.instant('OTP resent successfully'),
            'success'
          );
          this.router.navigate(['reset-password']);
        } else {
          swal.fire(
            '',
            this.translate.instant('RESETPASSWORDFORM.Unauthorized_User'),
            'error'
          );
        }
      }, (error) => {
        const e = error.error;
        swal.fire(
          '',
          this.translate.instant(e.message),
          'info'
        );
      });
    }
}
